const { onlyAlphaNumeric, SPACE } = require('../helpers');

const states = {
  'Grand Cayman': 'Grand Cayman',
  'Little Cayman': 'Little Cayman',
  'Cayman Brac': 'Cayman Brac'
};

const stateOptions = [];
for (const key of Object.keys(states)) {
  stateOptions.push({ value: key, name: states[key] });
}

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyAlphaNumeric(zipCode);
  if (zipCode.length <= 6) {
    return zip;
  }
  return `${zip.slice(0, 3).toUpperCase()}-${zip.slice(3, 8)}`;
};

exports.countryDefinition = {
  country: 'Cayman Islands',
  code: 'KY',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town' },
    stateCode: {
      type: 'array',
      array: stateOptions,
      label: 'Island',
      width: 0.5
    },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  states,
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['stateCode', SPACE, SPACE, 'zipCode', SPACE, 'city']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['zipCode', 'stateCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^KY[1-3]{1}-[0-9]{4}$/),
      error: 'Must be KY + island code + 4 numbers, KY1-1100'
    }
  ]
};
